// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sample-editor {
    background-color: thistle;
    padding: 20px;
    max-height: 90vh;
    overflow-y: auto;
}

.sample-editor .graphs {
    overflow: hidden;
}
.sample-editor .graphs table {
    float: left;
}

.sample-editor .tone-column {
    margin: 10px 0 10px 10px;
}
.sample-editor .tone-column td {
    font-size: 13px;
    height: 16px;
    width: 48px;
    padding: 0;
}
.sample-editor .tone-column td input {
    height: 13px;
    font-size: 13px;
    padding: 0;
    border: none;
    outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/sample_editor.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,UAAU;AACd;AACA;IACI,YAAY;IACZ,eAAe;IACf,UAAU;IACV,YAAY;IACZ,aAAa;AACjB","sourcesContent":[".sample-editor {\n    background-color: thistle;\n    padding: 20px;\n    max-height: 90vh;\n    overflow-y: auto;\n}\n\n.sample-editor .graphs {\n    overflow: hidden;\n}\n.sample-editor .graphs table {\n    float: left;\n}\n\n.sample-editor .tone-column {\n    margin: 10px 0 10px 10px;\n}\n.sample-editor .tone-column td {\n    font-size: 13px;\n    height: 16px;\n    width: 48px;\n    padding: 0;\n}\n.sample-editor .tone-column td input {\n    height: 13px;\n    font-size: 13px;\n    padding: 0;\n    border: none;\n    outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
